import PageLayout from "@/components/landing/PageLayout";
import Testimonials from "@/components/landing/Testimonials";

export default function ClientsPage() {
  return (
    <PageLayout testId="clients-page-root">
      <section className="relative isolate overflow-hidden border-b border-white/5">
        <div className="hero-glow" aria-hidden />
        <div className="absolute inset-0 grid-pattern" aria-hidden />
        <div className="relative mx-auto max-w-6xl px-5 py-16 md:px-6 md:py-24">
          <div className="inline-flex items-center gap-2 rounded-full border border-blue-500/20 bg-blue-500/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-blue-300">
            Our clients
          </div>
          <h1 className="mt-5 max-w-3xl font-display text-4xl font-extrabold leading-tight text-white sm:text-5xl lg:text-6xl">
            Trusted by <span className="gradient-text">200+ businesses</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base text-slate-300 sm:text-lg">
            From local shops to multi-location brands — here are the industries we've helped scale.
          </p>
        </div>
      </section>

      <Testimonials />
    </PageLayout>
  );
}
